export * from './index.component';
export * from './model-sections.component';
export * from './model-points.component';
